import { calculator } from '../../../api';
import { call, takeLatest, put } from 'redux-saga/effects';
import {
  FETCH_CALCULATOR_CONFIG,
  FETCH_CALCULATOR_CONFIG_START,
  FETCH_CALCULATOR_CONFIG_COMPLETE,
  FETCH_CALCULATOR_CONFIG_ERROR,
  CALCULATE_RESULTS,
  CALCULATE_RESULTS_START,
  CALCULATE_RESULTS_COMPLETE,
  CALCULATE_RESULTS_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setUserStatusUnauthorised } from '../userProfile/actions';

export function* fetchCalculatorConfigSaga() {
  try {
    yield put({ type: FETCH_CALCULATOR_CONFIG_START });
    const { response, error } = yield call(calculator.getCalculatorConfig);

    if (response) {
      yield put({
        type: FETCH_CALCULATOR_CONFIG_COMPLETE,
        payload: { config: response },
      });
    } else {
      if (error?.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put({
          type: FETCH_CALCULATOR_CONFIG_ERROR,
          payload: {
            error: error?.data?.message || errorStrings.commonError,
          },
        });
      }
    }
  } catch (err) {
    yield put({
      type: FETCH_CALCULATOR_CONFIG_ERROR,
      payload: { error: errorStrings.commonError },
    });
  }
}

export function* calculateResultsSaga({ payload }) {
  try {
    yield put({ type: CALCULATE_RESULTS_START });
    const { response, error } = yield call(calculator.calculateResults, payload);

    if (response) {
      yield put({
        type: CALCULATE_RESULTS_COMPLETE,
        payload: { result: response },
      });
    } else {
      if (error?.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put({
          type: CALCULATE_RESULTS_ERROR,
          payload: {
            error: error?.data?.message || errorStrings.commonError,
          },
        });
      }
    }
  } catch (err) {
    yield put({
      type: CALCULATE_RESULTS_ERROR,
      payload: { error: errorStrings.commonError },
    });
  }
}

function* watchFetchCalculatorConfig() {
  yield takeLatest(FETCH_CALCULATOR_CONFIG, fetchCalculatorConfigSaga);
}

function* watchCalculateResults() {
  yield takeLatest(CALCULATE_RESULTS, calculateResultsSaga);
}

export const sagas = [
  watchFetchCalculatorConfig,
  watchCalculateResults,
];
